import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import CancelRounded from '@mui/icons-material/CancelRounded';
import BaseTable from '../common/BaseTable';

const useStyles = makeStyles(() => ({
  actionCellContent: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}));

export default function Subprojects({ rows, projectId }) {
  const classes = useStyles();

  const headCells = [
    { key: 'name', label: 'Subproject Name' },
    { key: 'start_date', label: 'Start Date' },
    { key: 'description', label: 'Description' },
    { key: 'status', label: 'Status' },
    {
      key: 'action', label: '', customContent: true, unclickable: true,
    },
  ];

  const handleRowClick = ({ id }) => {
    window.location.href = `/projects/${projectId}/subprojects/${id}/edit`;
  };

  const customCellContentProvider = (row, key) => {
    if (key === 'action') {
      return (
        <div className={classes.actionCellContent}>
          <a
            data-confirm="Are you sure you want to delete this subproject?"
            rel="nofollow"
            data-method="delete"
            href={`/projects/${projectId}/subprojects/${row.id}`}
          >
            <CancelRounded color="error" fontSize="small" />
          </a>
        </div>
      );
    }

    return null;
  };

  return (
    <BaseTable
      rows={rows}
      headCells={headCells}
      handleRowClick={handleRowClick}
      customCellContentProvider={customCellContentProvider}
    />
  );
}
